import { Card, CardBody, CardHeader } from '@heroui/card';
import i18n from '@/i18n/config';

import DefaultLayout from '@/layouts/default';

// Import all chart components
import { UsersGrowthChart } from '@/components/charts/sample/UsersGrowthChart';
import { ErrorsAreaChart } from '@/components/charts/sample/ErrorsAreaChart';
import { DomainsBarChart } from '@/components/charts/sample/DomainsBarChart';
import { FeatureRadarChart } from '@/components/charts/sample/FeatureRadarChart';
import { SalesPerformanceChart } from '@/components/charts/sample/SalesPerformanceChart';
import { TaskDistributionChart } from '@/components/charts/sample/TaskDistributionChart';
import { TechRankChart } from '@/components/charts/sample/TechRankChart';
import { AcquisitionFunnelChart } from '@/components/charts/sample/AcquisitionFunnelChart';
import { ActivityHeatmapChart } from '@/components/charts/sample/ActivityHeatmapChart';

export default function IndexPage() {
  return (
    <DefaultLayout>
      <div className="p-4">
        <h1 className="mb-6 text-2xl font-bold">{i18n.t('pages.dashboard.title')}</h1>

        {/* Admin Dashboard Layout */}
        <div className="grid grid-cols-1 gap-2 md:grid-cols-3 lg:grid-cols-4">
          {/* Row 1: Large Charts */}
          {/* Users Growth Chart - Wide */}
          <Card
            className="md:col-span-2 lg:col-span-2 xl:col-span-2"
            classNames={{ base: 'border border-gray-200' }}
            radius="sm"
            shadow="none"
          >
            <CardHeader className="pb-0">
              <h3 className="text-lg font-semibold">{i18n.t('pages.dashboard.usersGrowth')}</h3>
            </CardHeader>
            <CardBody className="pt-0">
              <UsersGrowthChart />
            </CardBody>
          </Card>

          {/* Errors Area Chart - Wide */}
          <Card
            className="md:col-span-2 lg:col-span-2 xl:col-span-2"
            classNames={{ base: 'border border-gray-200' }}
            radius="sm"
            shadow="none"
          >
            <CardHeader className="pb-0">
              <h3 className="text-lg font-semibold">{i18n.t('pages.dashboard.errorTrends')}</h3>
            </CardHeader>
            <CardBody className="pt-0">
              <ErrorsAreaChart />
            </CardBody>
          </Card>

          {/* Row 2: Medium Charts */}
          {/* Domains Bar Chart - Medium */}
          <Card
            className="md:col-span-3 lg:col-span-3 xl:col-span-3"
            classNames={{ base: 'border border-gray-200' }}
            radius="sm"
            shadow="none"
          >
            <CardHeader className="pb-0">
              <h3 className="text-base font-semibold">{i18n.t('pages.dashboard.domainStatus')}</h3>
            </CardHeader>
            <CardBody className="pt-0">
              <DomainsBarChart />
            </CardBody>
          </Card>

          <div>
            {/* Experiments Pie Chart - Medium */}
            {/* Task Distribution Chart - Small */}
            <Card
              className="md:col-span-1 lg:col-span-1 xl:col-span-1"
              classNames={{ base: 'border border-gray-200' }}
              radius="sm"
              shadow="none"
            >
              <CardHeader className="pb-0">
                <h3 className="text-sm font-semibold">{i18n.t('pages.dashboard.taskDistribution')}</h3>
              </CardHeader>
              <CardBody className="pt-0">
                <TaskDistributionChart />
              </CardBody>
            </Card>
          </div>

          <div className="flex flex-col gap-2 md:col-span-3 lg:col-span-3 xl:col-span-3">
            {/* Feature Radar Chart - Medium */}
            <Card className="" classNames={{ base: 'border border-gray-200' }} radius="sm" shadow="none">
              <CardHeader className="pb-0">
                <h3 className="text-base font-semibold">{i18n.t('pages.dashboard.featureComparison')}</h3>
              </CardHeader>
              <CardBody className="pt-0">
                <FeatureRadarChart />
              </CardBody>
            </Card>
            {/* Sales Performance Chart - Medium */}
            <Card
              className="md:col-span-1 lg:col-span-1 xl:col-span-1"
              classNames={{ base: 'border border-gray-200' }}
              radius="sm"
              shadow="none"
            >
              <CardHeader className="pb-0">
                <h3 className="text-base font-semibold">{i18n.t('pages.dashboard.salesPerformance')}</h3>
              </CardHeader>
              <CardBody className="pt-0">
                <SalesPerformanceChart />
              </CardBody>
            </Card>
            {/* Acquisition Funnel Chart - Small */}
            <Card
              className="md:col-span-1 lg:col-span-1 xl:col-span-1"
              classNames={{ base: 'border border-gray-200' }}
              radius="sm"
              shadow="none"
            >
              <CardHeader className="pb-0">
                <h3 className="text-sm font-semibold">{i18n.t('pages.dashboard.acquisitionFunnel')}</h3>
              </CardHeader>
              <CardBody className="pt-0">
                <AcquisitionFunnelChart />
              </CardBody>
            </Card>
          </div>

          {/* Row 4: Full Width Chart */}
          {/* Activity Heatmap Chart - Full Width */}
          <Card className="col-span-2" classNames={{ base: 'border border-gray-200' }} radius="sm" shadow="none">
            <CardHeader className="pb-0">
              <h3 className="text-lg font-semibold">{i18n.t('pages.dashboard.activityHeatmap')}</h3>
            </CardHeader>
            <CardBody className="pt-0">
              <ActivityHeatmapChart />
            </CardBody>
          </Card>

          {/* Tech Rank Chart - Small */}
          <Card
            className="md:col-span-2 lg:col-span-2 xl:col-span-2"
            classNames={{ base: 'border border-gray-200' }}
            radius="sm"
            shadow="none"
          >
            <CardHeader className="pb-0">
              <h3 className="text-sm font-semibold">{i18n.t('pages.dashboard.techRankings')}</h3>
            </CardHeader>
            <CardBody className="pt-0">
              <TechRankChart />
            </CardBody>
          </Card>
        </div>
      </div>
    </DefaultLayout>
  );
}
